"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Form = _interopRequireDefault(require("reactstrap/lib/Form"));

var _formik = require("formik");

var Yup = _interopRequireWildcard(require("yup"));

var _utils = require("../lib/utils");

require("./form.css");

var _excluded = ["onSubmit", "withValidation", "validate", "dataTestId"],
    _excluded2 = ["handleSubmit"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Form = function Form(props) {
  var onSubmit = props.onSubmit,
      withValidation = props.withValidation,
      validate = props.validate,
      dataTestId = props.dataTestId,
      attr = (0, _objectWithoutProperties2["default"])(props, _excluded);

  if (withValidation) {
    return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
      isInitialValid: attr.isInitialValid,
      initialValues: attr.initialValues,
      enableReinitialize: attr.enableReinitialize,
      validationSchema: (0, _utils.isFunction)(attr.validationSchema) && attr.validationSchema(Yup),
      validate: (0, _utils.isFunction)(validate) && validate,
      onSubmit: onSubmit
    }, function (_ref) {
      var handleSubmit = _ref.handleSubmit,
          formikProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded2);
      return /*#__PURE__*/_react["default"].createElement(_Form["default"], {
        "data-testid": dataTestId,
        className: (0, _utils.gatherClasses)(attr),
        onSubmit: handleSubmit,
        inline: attr.inline,
        innerRef: attr.innerRef,
        noValidate: attr.noValidate
      }, (0, _utils.isFunction)(attr.renderChildren) && attr.renderChildren(formikProps));
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_Form["default"], (0, _extends2["default"])({
    "data-testid": dataTestId,
    className: (0, _utils.gatherClasses)(attr)
  }, attr, {
    onSubmit: onSubmit
  }), attr.children);
};

Form.propTypes = {
  children: _propTypes["default"].node,
  inline: _propTypes["default"].bool,
  noValidate: _propTypes["default"].bool,
  innerRef: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].string]),
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  validate: _propTypes["default"].func,
  withValidation: _propTypes["default"].bool,
  onSubmit: _propTypes["default"].func,
  enableReinitialize: _propTypes["default"].bool
};
Form.defaultProps = {
  noValidate: true,
  inline: false,
  withValidation: false,
  onSubmit: function onSubmit() {},
  dataTestId: "orion-form"
};
Form.displayName = "OrionForm";
var _default = Form;
exports["default"] = _default;